
import { createClient } from '@supabase/supabase-js';

// Retrieve Supabase configuration from environment variables.
// Provide clear error messages if the required variables are missing.
const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl) {
  throw new Error(
    'Supabase URL is missing. Please set VITE_PUBLIC_SUPABASE_URL in your environment.'
  );
}

if (!supabaseAnonKey) {
  throw new Error(
    'Supabase anon key is missing. Please set VITE_PUBLIC_SUPABASE_ANON_KEY in your environment.'
  );
}

// Create and export a single Supabase client instance.
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
